/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jesse on 5/6/16.
 */
'use strict';
angular.module('prism-ui.components').controller('PackagePropertiesFilterSectionController',
    function ($scope, $q, ExternalMetadataService, SearchFilterService, PackagePropertiesQueryService, $location, PermissionsService) {
        var self = this;
        self.available = {
            contentTypes: [],
            networks: [],
            categoryTypes: [],
            categories: [],
            contents: [],
            seasons: [],
            volumes: [],
            submitters: [],
            externalSystems: [],
        };

        self.searchCriteria = {
            contentType: undefined,
            networks: [],
            categoryTypes: [],
            categories: [],
            contents: [],
            externalSystems: [],
        };

        self.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        var contentSetFromLocation = false;
        var seasonVolumeSetFromLocation = false;
        var categoriesSetFromLocation = false;
        var unfilteredContents = [];
        var packageView;
        var objectProp;

        var getAvailableCategories = function () {
            var allCategories = [];
            if (self.searchCriteria.categoryTypes && self.searchCriteria.categoryTypes.length) {
                angular.forEach(self.searchCriteria.categoryTypes, function (categoryType) {
                    allCategories = allCategories.concat(categoryType.categories);
                });
            }
            else {
                angular.forEach(self.available.categoryTypes, function (categoryType) {
                    allCategories = allCategories.concat(categoryType.categories);
                });
            }
            return allCategories;
        };

        var retrieveData = function () {
            packageView = $location.path().indexOf('dashboard/workflow') === -1;
            objectProp = (packageView)? 'id' : 'name';

            self.loadingIndicator.show = true;
            var contentTypesPromise = PackagePropertiesQueryService.getContentTypes();
            var networksPromise = PackagePropertiesQueryService.getNetworks();
            var categoriesPromise = PackagePropertiesQueryService.getCategories();
            var submittersPromise = (!packageView && PermissionsService.isAdmin())? SearchFilterService.getSubmitters() : null;
            var externalSystemsPromise = ExternalMetadataService.getExternalSources();
            $q.all({
                contentTypes: contentTypesPromise,
                networks: networksPromise,
                categories: categoriesPromise,
                submitters: submittersPromise,
                externalSystems: externalSystemsPromise,
            }).then(function (data) {
                self.available.contentTypes = data.contentTypes;
                self.available.networks = data.networks;
                self.available.categoryTypes = data.categories;
                self.available.categories = getAvailableCategories();
                self.available.submitters = data.submitters;
                self.available.externalSystems = data.externalSystems;

                self.searchCriteria.contentType = $location.search().contentType;
                self.searchCriteria.categoryTypes = SearchFilterService.getObjectsFromPathProp(self.available.categoryTypes, objectProp, 'categoryType');
                self.searchCriteria.networks = SearchFilterService.getObjectsFromPathProp(self.available.networks, objectProp, 'network');
                if (packageView) {
                    self.searchCriteria.externalSystems = SearchFilterService.getObjectsFromPathProp(self.available.externalSystems, 'systemName', 'externalSystem');
                } else {
                    self.searchCriteria.submitters = SearchFilterService.getObjectsFromPathProp(self.available.submitters, 'id', 'submitters');
                }
                // Value set in the watcher if url criteria contains categoryType
                if (!$location.search().hasOwnProperty('categoryType') || !$location.search().categoryType.length) {
                    self.searchCriteria.categories = SearchFilterService.getObjectsFromPathProp(self.available.categories, objectProp, 'category');
                }
                self.loadingIndicator.show = false;
            });
        };

        var getAvailableSeasonsVolumes = function (contents) {
            var allSeasons = [];
            var allVolumes = [];
            if (contents.length === 1) {
                angular.forEach(contents, function (content) {
                    angular.forEach(content.seasons, function (season) {
                        allSeasons.push(season);
                    });
                    angular.forEach(content.volumes, function (volume) {
                        allVolumes.push(volume);
                    });
                });
            }
            else {
                angular.forEach(contents, function (content) {
                    angular.forEach(content.seasons, function (season) {
                        season.name = content.prefix + '-' + season.name;
                        allSeasons.push(season);
                    });
                    angular.forEach(content.volumes, function (volume) {
                        volume.name = content.prefix + '-' + volume.name;
                        allVolumes.push(volume);
                    });
                });
            }
            return {
                seasons: allSeasons,
                volumes: allVolumes
            };
        };

        function filterContentByNetworks(contents, networks) {
            var valid = [];
            if (!(networks && networks.length)) {
                return contents;
            }
            angular.forEach(contents, function (content) {
                for (var i = 0; i < networks.length; i++) {
                    var network = networks[i];
                    if (network.id === content.network.id) {
                        valid.push(content);
                    }
                }
            });
            return valid;
        }

        $scope.$watch(function () {
                return self.searchCriteria.networks.length;
            },
            function (newVal) {
                if (newVal) {
                    self.available.contents = filterContentByNetworks(unfilteredContents, self.searchCriteria.networks);
                    self.searchCriteria.contents = filterContentByNetworks(self.searchCriteria.contents, self.searchCriteria.networks);
                }
            });

        $scope.$watch(function () {
                return self.searchCriteria.categoryTypes.length;
            },
            function () {
                self.available.categories = getAvailableCategories();
                if ($location.search().category && !categoriesSetFromLocation) {
                    self.searchCriteria.categories = SearchFilterService.getObjectsFromPathProp(self.available.categories, objectProp, 'category');
                }
            });

        var removeInvalidSeasonsVolumes = function (availableCollection, selectedCollection) {
            var valid = [];
            angular.forEach(selectedCollection, function (selection) {
                for (var i = 0; i < availableCollection.length; i++) {
                    var available = availableCollection[i];
                    if (available.id === selection.id) {
                        valid.push(available);
                        break;
                    }
                }
            });

            return valid;
        };

        var onSeriesChanged = function (newContents) {
            if (newContents) {
                PackagePropertiesQueryService.getSeasonsVolumesForContents(self.searchCriteria.contents).then(function (contentWithSeasonsVolumes) {
                    var seasonsVolumes = getAvailableSeasonsVolumes(contentWithSeasonsVolumes);
                    self.available.seasons = seasonsVolumes.seasons;
                    self.available.volumes = seasonsVolumes.volumes;
                    self.searchCriteria.seasons = removeInvalidSeasonsVolumes(self.available.seasons, self.searchCriteria.seasons);
                    self.searchCriteria.volumes = removeInvalidSeasonsVolumes(self.available.volumes, self.searchCriteria.volumes);
                    if (($location.search().season || $location.search().volume) && !seasonVolumeSetFromLocation) {
                        self.searchCriteria.seasons = SearchFilterService.getObjectsFromPathProp(self.available.seasons, objectProp, 'season');
                        self.searchCriteria.volumes = SearchFilterService.getObjectsFromPathProp(self.available.volumes, objectProp, 'volume');
                        seasonVolumeSetFromLocation = true;
                    }
                });
            }
            else {
                self.available.seasons = [];
                self.searchCriteria.seasons = [];
                self.available.volumes = [];
                self.searchCriteria.volumes = [];
            }
        };

        $scope.$watch(function () {
                return self.searchCriteria.contentType;
            },
            function (newVal, oldValue) {
                self.available.contents = [];
                self.searchCriteria.contents = [];
                if(packageView) {
                    self.searchCriteria.seasons = [];
                    self.searchCriteria.volumes = [];
                }
                if (newVal) {
                    PackagePropertiesQueryService.getContents(newVal).then(function (contents) {
                        unfilteredContents = angular.copy(contents);
                        self.available.contents = filterContentByNetworks(unfilteredContents, self.searchCriteria.networks);
                        if ($location.search().content && !contentSetFromLocation) {
                            self.searchCriteria.contents = SearchFilterService.getObjectsFromPathProp(self.available.contents, objectProp, 'content');
                            contentSetFromLocation = true;
                        }
                    });

                    if (packageView && self.searchCriteria.contentType === 'Series') {
                        $scope.$watch(function () {
                                return self.searchCriteria.contents.length;
                            },
                            onSeriesChanged);
                    }
                }
                else if (newVal !== oldValue) {
                    self.available.contents = [];

                    self.searchCriteria.contents = [];
                    self.searchCriteria.categoryTypes = [];
                    self.searchCriteria.categories = [];
                    self.searchCriteria.networks = [];
                    if(packageView) {
                        self.searchCriteria.seasons = [];
                        self.searchCriteria.volumes = [];
                        self.searchCriteria.externalSystems = [];
                    }
                }
            });

        self.submitterDropdownLabelFxn = function (submitter) {
            let firstName = (submitter.firstName) ? submitter.firstName : '';
            let lastName = (submitter.lastName) ? submitter.lastName : '';
            let label = (firstName + ' ' + lastName).trim();
            if (!label) {
                return submitter.username;
            }
            return label;
        };

        $scope.$on('modal.closing', function () {
            SearchFilterService.getCurrentSearchCriteria().contentType = self.searchCriteria.contentType;
            SearchFilterService.getCurrentSearchCriteria().network = SearchFilterService.extractQueryProp(self.searchCriteria.networks, objectProp);
            SearchFilterService.getCurrentSearchCriteria().categoryType = SearchFilterService.extractQueryProp(self.searchCriteria.categoryTypes, objectProp);
            SearchFilterService.getCurrentSearchCriteria().category = SearchFilterService.extractQueryProp(self.searchCriteria.categories, objectProp);
            SearchFilterService.getCurrentSearchCriteria().content = SearchFilterService.extractQueryProp(self.searchCriteria.contents, objectProp);
            if(packageView) {
                SearchFilterService.getCurrentSearchCriteria().season = SearchFilterService.extractQueryProp(self.searchCriteria.seasons, objectProp);
                SearchFilterService.getCurrentSearchCriteria().volume = SearchFilterService.extractQueryProp(self.searchCriteria.volumes, objectProp);
                SearchFilterService.getCurrentSearchCriteria().externalSystem = SearchFilterService.extractQueryProp(self.searchCriteria.externalSystems, 'systemName');
            } else {
                SearchFilterService.getCurrentSearchCriteria().submitters = SearchFilterService.extractQueryProp(self.searchCriteria.submitters, 'id');
            }
        });

        retrieveData();
    });
